import { getFormattedLink } from "src/helpers/utils";
import { ECONTACT_TYPE } from "./SourceAddContactDetailsModal";
import clsx from "clsx";
import { CONTACT_DEFAULT_ICONS, ICON_SIZES } from "src/helpers/constants";
import Icon from "src/components/Icon/Icon";
import { AnimatePresence, motion } from "framer-motion";
import ButtonGroup from "src/components/ButtonGroup/ButtonGroup";
import { MdDelete, MdEdit } from "react-icons/md";
import { IButton } from "src/components/Button/Button";

interface ISourcesContactCards {
  items: any[];
  actions?: IButton[];
  columns?: number;
}

const SourcesContactCards: React.FC<ISourcesContactCards> = ({
  items,
  actions = [],
  columns = 1,
}) => {
  if (!items?.length) return null;

  return (
    <div
      className={clsx([
        "grid",
        "grid-cols-1",
        `md:grid-cols-${columns}`,
        {
          // "md:grid-cols-2": items?.length > 1,
        },
        "gap-2",
        "md:gap-2",
        "w-full",
      ])}
    >
      <AnimatePresence mode="wait">
        {items?.map?.((data: any, key: number) => {
          return (
            <motion.a
              key={key}
              className={clsx([
                "flex",
                "flex-row",
                "w-full",
                "bg-blue-100/60 dark:bg-gray-900/50",
                "p-2 md:p-4",
                "rounded-md",
                "md:gap-4",
                "gap-2",
                "md:text-base",
                "text-sm",
              ])}
              href={getFormattedLink({
                type: data?.type,
                value: data?.value,
              })}
              target={data?.type === ECONTACT_TYPE.LINK ? "_blank" : ""}
              initial={{
                opacity: 0,
                x: key % 2 === 0 ? -100 : 100,
              }}
              animate={{ opacity: 1, x: 0 }}
              transition={{
                duration: 0.3,
                ease: "easeOut",
                delay: key * 0.1,
              }}
            >
              <div
                className={clsx([
                  "flex",
                  "flex-row",
                  "gap-2",
                  "md:gap-4",
                  "flex-grow",
                  "flex-shrink",
                  "truncate",
                ])}
              >
                <div>
                  <Icon
                    name={
                      data?.icon ||
                      CONTACT_DEFAULT_ICONS[data?.type as ECONTACT_TYPE]
                    }
                    size={ICON_SIZES.LG}
                    className={clsx(["dark:text-cyan-400", "text-blue-400"])}
                  />
                </div>
                <div className={clsx(["truncate"])}>
                  <div>{data?.name || "Sin nombre"}</div>
                  <div className={clsx(["truncate"])}>{data?.value}</div>
                </div>
              </div>
              {actions?.length > 0 && (
                <div
                  onClick={(e) => {
                    e.stopPropagation?.();
                    e?.preventDefault?.();
                  }}
                >
                  <ButtonGroup
                    buttons={actions.map((action) => ({
                      ...action,
                      onClick: (e: any) => {
                        e.stopPropagation();
                        e.preventDefault();
                        action.onClick?.(e);
                      },
                    }))}
                  />
                </div>
              )}
            </motion.a>
          );
        })}
      </AnimatePresence>
    </div>
  );
};

export default SourcesContactCards;
